import {
    TonConnectUIProviderPropsBase,
    TonConnectUIProviderPropsWithConnector,
    TonConnectUIProviderPropsWithManifest,
} from '@tonconnect/ui-react';

declare type TonConnectUIProviderProps = Partial<TonConnectUIProviderPropsBase> &
    Partial<TonConnectUIProviderPropsWithManifest | TonConnectUIProviderPropsWithConnector>;

export const tonConnectUIProviderConfig: TonConnectUIProviderProps = {
    manifestUrl: 'https://ton-connect.github.io/demo-dapp-with-react-ui/tonconnect-manifest.json',
    actionsConfiguration: {
        modals: 'all',
        notifications: 'all',
    },
    language: 'en',
};
